// Lazily load the large books dataset as a separate chunk.
// This avoids bundling src/data/books.json into the initial JS payload.

let booksPromise;

export const loadBooksData = async () => {
  if (!booksPromise) {
    booksPromise = import('../data/books.json').then((m) => m.default || m);
  }
  return booksPromise;
};
